/**
 * Utilidades para pedidos programados (Scheduled Orders)
 */

/**
 * Formatea un timestamp ISO a hora legible (HH:mm) en la zona horaria del comercio.
 * @param {string} isoString - Timestamp ISO (ej: "2026-03-20T14:00:00Z")
 * @param {string} [timezone] - Zona horaria IANA (ej: "America/Mexico_City"). Default: zona local del navegador.
 * @returns {string} Hora formateada (ej: "14:00")
 */
export const formatScheduledTime = (isoString: string, timezone?: string): string => {
  try {
    const date = new Date(isoString);
    return date.toLocaleTimeString('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...(timezone ? { timeZone: timezone } : {}),
    });
  } catch {
    return isoString;
  }
};

/**
 * Formatea un timestamp ISO a fecha + hora legible.
 * @param {string} isoString - Timestamp ISO
 * @param {string} [timezone] - Zona horaria IANA
 * @returns {string} Fecha y hora formateada (ej: "20 mar 14:00")
 */
export const formatScheduledDateTime = (isoString: string, timezone?: string): string => {
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString('es-MX', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...(timezone ? { timeZone: timezone } : {}),
    });
  } catch {
    return isoString;
  }
};
